import api from '../../api.js';

export const MODAL_SELECTOR = api.core.ns.selector('modal');
export const MODAL_CLASS = api.core.ns('modal');
export const NO_SCROLL_CLASS = api.core.ns('no-scroll');
export const SCROLL_SHADOW_CLASS = api.core.ns('scroll-shadow');
export const MODAL_BODY_SELECTOR = api.core.ns.selector('modal__body');
export const OFFSET_MOBILE = 32; // 32px => 8v => 2rem
